import React from "react";
import { Route, Routes } from "react-router-dom";
import ListProjects from "../Components/Manage Projects/listProjects";
import ViewProjects from "../Components/Manage Projects/viewProjects";
import AllProjects from "../Components/Manage Projects/allProjects";
import ViewProjectsCatalogue from "../Components/Manage Projects/viewProjectsCatalogue";
import AddProject from "../Components/Manage Projects/addProjects";
import AddProperties from "../Components/Properties/addProperties";
import EditProject from "../Components/Manage Projects/editProjects";
import showPriceList from "../Components/Manage Projects/ShowPriceList";
import ShowPriceList from "../Components/Manage Projects/ShowPriceList";

const ManageProjectsRoutes = () => {
  return (
    <Routes>
      <Route
        path="/manage_projects"
        element={<AllProjects/>}
      ></Route>
      <Route
        path="/manage_projects/add"
        element={<AddProject></AddProject>}
      ></Route>
      <Route
        path="/manage_projects/list"
        element={<ListProjects></ListProjects>}
      ></Route>
      <Route
        path="/manage_projects/view/:id"
        element={<ViewProjects></ViewProjects>}
      ></Route>
      <Route
        path="/manage_projects/add_property/:id"
        element={<AddProperties></AddProperties>}
      ></Route>
      <Route
        path="/manage_projects/edit/:id"
        element={<EditProject></EditProject>}
      ></Route>
      <Route
        path="/manage_projects/view/catalogue/:id"
        element={<ViewProjectsCatalogue></ViewProjectsCatalogue>}
      ></Route>
      <Route
        path="/manage_projects/show_price_list/:id"
        element={<ShowPriceList></ShowPriceList>}
      ></Route>
    </Routes>
  );
};

export default ManageProjectsRoutes;
